// imports
import { useState, useCallback, cloneElement } from 'react'
import { createPortal } from 'react-dom'

// utils
import useWindowSize from '@/hooks/useWindowSize'
import { useConfig } from '@/hooks/useConfig'

// styles
import './NavTooltip.scss'

interface NavTooltipProps {
    content: string
    children: React.ReactElement
}

const NAV_TOOLTIP_OFFSET_PX = 8

const NavTooltip = ({ content, children }: NavTooltipProps) => {
    const [rect, setRect] = useState<DOMRect | null>(null)
    const { isMobile, isTablet } = useWindowSize()
    const { isDarkTheme } = useConfig()

    const handleMouseEnter = useCallback((e: React.MouseEvent<HTMLElement>) => {
        setRect(e.currentTarget.getBoundingClientRect())
    }, [])

    const handleMouseLeave = useCallback(() => {
        setRect(null)
    }, [])

    const child = cloneElement(
        children as React.ReactElement<React.HTMLAttributes<HTMLElement>>,
        {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
        }
    )

    const isDesktop = !isMobile && !isTablet

    return (
        <>
            {child}
            {isDesktop && rect && content && createPortal(
                <span
                    className={`nav-tooltip ${isDarkTheme ? '-dark-mode' : ''}`}
                    style={{
                        top: rect.top + rect.height / 2,
                        left: rect.right + NAV_TOOLTIP_OFFSET_PX,
                    }}
                >
                    {content}
                </span>,
                document.body
            )}
        </>
    )
}

export default NavTooltip
